import React from 'react';
import styles from './index.module.scss';

import vidLarge from './slides-v2@large.mp4';
import vidSmall from './slides-v2@small.mp4';
import posterLarge from './poster@large.jpg';
import posterSmall from './poster@small.jpg';

/* eslint-disable react/prop-types */
export default ({ locale }) => (
  <div className={styles.root}>
    <div className={styles.overlay}>
      <h1 className={styles.title}>{locale === 'en' ? `Discover Kingston` : `探索京斯敦`}</h1>
    </div>

    <div className={styles.videoWrapper}>
      <video autoPlay loop muted playsInline poster={posterLarge} className={styles.large}>
        <source src={vidLarge} type="video/mp4" />
      </video>

      <video autoPlay loop muted playsInline poster={posterSmall} className={styles.small}>
        <source src={vidSmall} type="video/mp4" />
      </video>
    </div>

    <div className={styles.scroll}>
      <div className={styles.text}>
        <p>{locale === 'en' ? `Scroll down to learn more` : `向下滾動以了解更多信息`}</p>
      </div>
      <div className={styles.arrow} />
    </div>
  </div>
);
